import React, { Component } from 'react';
import moment from 'moment';
import './RoomListCell.css';

/**
 * The cell component for the room listing on the main page.
 *
 * @class RoomListCell
 * @param {Object} room The room to render a cell for.
 * @param {String} room.name The name of the room.
 * @param {Date} room.lastJoined The date the user last joined the room.
 * @param {Array[Object]} room.friends The friends to optionally render.
 * @extends {Component}
 */
class RoomListCell extends Component {
  constructor(props) {
    super(props);
    this.renderAvatarItem = this.renderAvatarItem.bind(this);
  }

  handleClick = (ev) => {
    ev.preventDefault();
    const { onClick, room } = this.props;
    onClick(room);
  }

  openRoomSettings = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();

    const { openRoomSettings, room } = this.props;
    openRoomSettings(room);
  }

  renderAvatarItem(user) {
    return <li className="RoomListCell__avatar-list-item" key={user.id}>
      <img src={user.avatar} alt="" className="RoomListCell__avatar" />
    </li>;
  }

  render() {
    const { room } = this.props;
    const { name, lastJoined } = room;

    let friends = room.friends || [];

    let cellTagline = 'Last joined awhile ago';
    if (lastJoined) {
      let friendlyLastJoined = moment(lastJoined).fromNow();
      cellTagline = `Last joined ${friendlyLastJoined}`;
      if (friends.length) {
        const noun = friends.length === 1 ? 'friend' : 'friends';
        cellTagline = `${friends.length} ${noun} online`;
      }
    }

    const avatarList = friends.map(this.renderAvatarItem);

    return (
      <div className="RoomListCell" onClick={this.handleClick}>
        <div className="RoomListCell__info">
          <h3 className="RoomListCell__name">{name} <a onClick={this.openRoomSettings} className="RoomListCell__settings-link"><svg width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 7.892a2.392 2.392 0 1 1 0-4.784 2.392 2.392 0 0 1 0 4.784M9.942 5.5c0-.686.422-1.227 1.058-1.6a5.784 5.784 0 0 0-.453-1.094c-.713.187-1.29-.093-1.775-.578-.485-.485-.634-1.062-.447-1.775A5.77 5.77 0 0 0 7.23 0C6.858.636 6.186 1.058 5.5 1.058 4.814 1.058 4.142.636 3.77 0a5.78 5.78 0 0 0-1.095.453c.187.713.038 1.29-.447 1.775-.485.485-1.062.765-1.775.578A5.774 5.774 0 0 0 0 3.901c.636.372 1.058.913 1.058 1.599 0 .686-.422 1.358-1.058 1.73.114.383.266.75.453 1.095.713-.186 1.29-.038 1.775.447.485.485.634 1.062.447 1.775A5.76 5.76 0 0 0 3.77 11c.372-.636 1.044-1.058 1.73-1.058.686 0 1.358.422 1.73 1.058.383-.114.75-.266 1.095-.453-.186-.713-.038-1.29.447-1.775.485-.485 1.062-.764 1.775-.578.187-.345.339-.712.453-1.095-.636-.372-1.058-.913-1.058-1.599" /></svg><span className="RoomListCell__link-label">Settings</span></a></h3>
          <p className="RoomListCell__tagline">{cellTagline}</p>
        </div>
        <div className="RoomListCell__avatars">
          <ul className="RoomListCell__avatar-list">
            {avatarList}
          </ul>
        </div>
      </div>
    );
  }
}

export default RoomListCell;



// WEBPACK FOOTER //
// ./src/components/RoomListCell.js